import { useQuery } from "@tanstack/react-query";
import type { ContactAnnotationsResponse } from "@breeze/shared";
import { fetchContactAnnotations } from "../api.js";

export function useContactAnnotations(
  cid: number | null
): ReturnType<typeof useQuery<ContactAnnotationsResponse>> {
  return useQuery<ContactAnnotationsResponse>({
    queryKey: ["contact-annotations", cid],
    queryFn: () => fetchContactAnnotations(cid as number),
    enabled: cid !== null,
    staleTime: 60_000,
  });
}
